<template>
  <div class="divide-y overflow-hidden rounded-lg bb-component-background shadow-sm">
    <div class="px-4 py-5 sm:p-6">
      <img
          :src="
                `https://maps.googleapis.com/maps/api/staticmap?center=${data.place.lat},${data.place.lng}&zoom=13&size=600x300&maptype=roadmap&markers=color:green%7C${data.place.lat},${data.place.lng}&key=${apiKey}`
            "
          class="inset-0 w-full object-cover rounded-md max-h-80"
      />
    </div>
    <div class="px-4 py-4 sm:px-6" v-if="data.place.description">
      <a
          class="block-link text-center text-blue-500 cursor-pointer select-none"
          v-html="data.place.description"
          :href="data.place.url"
      ></a>
    </div>
  </div>


</template>

<script>
export default {
    name: "Place",
    props: {
        data: {
            type: Object,
            default: null
        },
        settings: {
            type: Object,
            default: null
        }
    },
    computed: {
        apiKey() {
            return process.env.VUE_APP_GOOGLE_MAP_API_KEY;
        }
    }
};
</script>
